import FileSaver  from 'file-saver'

export function saveCsv(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), filename)
}

export function saveIcs(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'text/calendar' }), filename)
}

export function savePng(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'image/png' }), filename)
}

export function saveJson(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'application/json' }), filename)
}

export function saveMarkdown(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'text/markdown' }), filename)
}

export function saveZip(data: any, filename: string) {
  FileSaver.saveAs(new Blob([data], { type: 'application/zip' }), filename)
}
